import {ReplyModel} from '@/models/reply.model';
import {BaseApi, RequireAuthApi} from '@/api/base.api';

export class ChallengeTopicMessagesApi extends BaseApi<ReplyModel> {
  constructor(public challengeId: number, public topicId: number) {
    super(`challenges/${challengeId}/forum/topics/${topicId}/messages`, [
      RequireAuthApi.CREATE,
      RequireAuthApi.UPDATE,
      RequireAuthApi.DESTROY,
    ]);
  }
}
